/** Styled pieces private to the volume-price tiers folder. */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { IndexedLayers } from "@ryerson/frontend.common";

/**
 * Private copy of SliderMenu for use within this component folder only.
 * The original in @components/Helper/commonStyles is shared site-wide and remains untouched.
 * Used by `MoreYouBuyMoreYouSaveMobile.tsx`; toggled with the `slide-open` / `slide-close` classes.
 */
export const SliderMenu = styled.div`
	transition: left 0.3s linear;
	position: fixed;
	width: 100%;
	top: 50px;
	height: 100vh;
	max-height: 100vh;
	overflow-y: auto;
	overflow-x: hidden;
	z-index: ${IndexedLayers.header};

	&.slide-open {
		left: 0%;
	}

	&.slide-close {
		left: -100%;
	}

	${(props: any) => {
		const { theme } = props;
		return css`
			background-color: ${theme.colors.primary.lighterGray};
		`;
	}}
`;

/**
 * Private copy of Divider for use within this component folder only.
 * The original in @components/ShoppingListDetails/Helpers/StyledComponent is shared and remains untouched.
 *
 * Nothing imports this copy.
 */
export const Divider = styled.div`
	width: 100%;
	opacity: 0.1;
	margin: 12px 0px;
	${(props: any) => {
		const { color } = props;
		return css`
			border-bottom: 1px solid ${color};
		`;
	}}
`;
